import React from 'react';

import { IbanElement } from '@stripe/react-stripe-js';
import type { StripeIbanElementChangeEvent } from '@stripe/stripe-js';

import { useCountryCode } from '#src/app/shared/hooks/l10n';
import { stripeElementDomId } from '#src/app/shared/utils/payments';

type Props = {
	onChange?: (event: StripeIbanElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const IbanElementWrapper: React.FC<Props> = (props) => {
	const countryCode = useCountryCode();
	return (
		<IbanElement
			id={stripeElementDomId('iban')}
			{...props}
			options={{
				supportedCountries: ['SEPA'],
				placeholderCountry: countryCode,
				style: { base: { fontSize: '16px' } },
			}}
		/>
	);
};
